export const ENV = import.meta.env.VITE_ENV ?? "development";

export const VERSION = import.meta.env.VITE_VERSION ?? "0.0.0";

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export const STATIC_ASSETS_BUCKET_PREFIX =
  import.meta.env.VITE_STATIC_ASSETS_BUCKET_PREFIX ?? "";

export const DOMAIN_NAME = import.meta.env.VITE_DOC_APP_DOMAIN_NAME ?? "mekidoc.cl";

export const API_URL = import.meta.env.VITE_API_URL;

// Replace is needed on production (the api url is different and contains the domain)
export const BASE_URL = API_URL?.replace(DOMAIN_NAME, "") ?? "";

export const PATIENT_APP_URL =
  import.meta.env.VITE_PATIENT_APP_URL ?? "https://paciente.mekidoc.cl";

export const MEKIDOC_SUPPORT_EMAIL = import.meta.env.VITE_MEKIDOC_SUPPORT_EMAIL ?? "";

if (!MEKIDOC_SUPPORT_EMAIL) {
  throw new Error("MEKIDOC_SUPPORT_EMAIL is not set");
}

export const MEKIDOC_SUPPORT_PHONE = import.meta.env.VITE_MEKIDOC_SUPPORT_PHONE ?? "";

if (!MEKIDOC_SUPPORT_PHONE) {
  throw new Error("MEKIDOC_SUPPORT_PHONE is not set");
}

export const MEKIDOC_GA4_TRACKING_ID = import.meta.env.VITE_MEKIDOC_GA4_TRACKING_ID ?? "";

export const MEKIDOC_GOOGLE_ADS_ID = import.meta.env.VITE_MEKIDOC_GOOGLE_ADS_ID ?? "";

export const DOCTOR_REGISTRATION_CONVERSION_ID =
  import.meta.env.VITE_DOCTOR_REGISTRATION_CONVERSION_ID ?? "";

export const DIC_APP_URL = import.meta.env.VITE_DIC_URL ?? "";
export const DIC_API_KEY = import.meta.env.VITE_DIC_API_KEY ?? "";

// Meki
export const MEKI_REST_API_URL =
  import.meta.env.VITE_MEKI_REST_API_URL ?? "https://rest.farmaciameki.cl";

// MeiliSearch
export const MEILI_SEARCH_HOST =
  import.meta.env.VITE_MEILI_SEARCH_HOST ?? "https://search.farmaciameki.cl";

export const MEILI_SEARCH_DEFAULT_API_KEY =
  import.meta.env.VITE_MEILI_SEARCH_DEFAULT_API_KEY ?? "";

// Clinical History API
export const API_GATEWAY_URL = import.meta.env.VITE_API_GATEWAY_URL ?? "";

// OpenReplay
export const OPENREPLAY_PROJECT_KEY = import.meta.env.VITE_OPENREPLAY_PROJECT_KEY;
export const OPENREPLAY_INGEST_POINT = import.meta.env.VITE_OPENREPLAY_INGEST_POINT;

export const OPENREPLAY_DISABLE_SECURE_MODE = import.meta.env
  .VITE_OPENREPLAY_DISABLE_SECURE_MODE;
